// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VA86","tabsBox":"styles_tabsBox__18G2x","createButton":"styles_createButton__30Q_r"};